import React from 'react'

import Sidebar from './Sidebar'

const Layout = (props) => {
    return (
        <>
           <Sidebar/>
    
            <>  
                {props.children}
            </>
        </>

    )
}

export default Layout